import * as THREE from 'three';

// Convenzione: y=up (nord), Italia = lat ~42.5, lon ~12.5.
export function latLonToVec3(lat, lon, r = 1) {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lon + 180) * (Math.PI / 180);
  return new THREE.Vector3(
    -r * Math.sin(phi) * Math.cos(theta),
     r * Math.cos(phi),
     r * Math.sin(phi) * Math.sin(theta),
  );
}

export function vec3ToLatLon(v) {
  const r = v.length();
  const lat = 90 - Math.acos(Math.max(-1, Math.min(1, v.y / r))) * 180 / Math.PI;
  let lng = Math.atan2(v.z, -v.x) * 180 / Math.PI - 180;
  if (lng < -180) lng += 360;
  return { lat, lng };
}

// Orientazione condivisa globo/pin (Italia verso camera)
export const GLOBE_EULER = new THREE.Euler(0, THREE.MathUtils.degToRad(-102.5), THREE.MathUtils.degToRad(-12));
const Q = new THREE.Quaternion().setFromEuler(GLOBE_EULER);
const Q_INV = Q.clone().invert();

export const worldDir = (lat, lng) => latLonToVec3(lat, lng, 1).applyQuaternion(Q).normalize();
export const worldToLatLng = (v) => vec3ToLatLon(v.clone().applyQuaternion(Q_INV));
export const zoomToDistance = (zoom = 6) => 1 + 2.3 * Math.pow(2, -(zoom - 6) / 1.6);
